var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaveCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.16876 56.48206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .a {\r\n        fill: #866e87;\r\n      }\r\n\r\n      .b {\r\n        fill: #fff;\r\n      }\r\n\r\n      .c {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 0.87993px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.30629.49991H51.86244a3.80615,3.80615,0,0,1,3.80615,3.80615V52.1752A3.80664,3.80664,0,0,1,51.862,55.98184H4.30678A3.80664,3.80664,0,0,1,.50014,52.1752V4.30606A3.80615,3.80615,0,0,1,4.30629.49991Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M52.02969,1.216a3.31017,3.31017,0,0,1,3.30642,3.30642V52.39161A3.31016,3.31016,0,0,1,52.02969,55.698H4.47375a3.31016,3.31016,0,0,1-3.30641-3.30641V4.52237A3.31016,3.31016,0,0,1,4.47375,1.216H52.02969m0-1H4.47375A4.30642,4.30642,0,0,0,.16734,4.52237V52.39161A4.30641,4.30641,0,0,0,4.47375,56.698H52.02969a4.30642,4.30642,0,0,0,4.30642-4.30641V4.52237A4.30643,4.30643,0,0,0,52.02969.216Z",
    transform: "translate(-0.16734 -0.21595)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "24.297 42.1 23.192 39.891 21.673 23.322 24.297 24.15 27.61 39.615 24.297 42.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M26.842,41.63233l-.10648,3.46079L25.56418,42.5907l1.27782-.95837m.93579-1.80175L24.464,42.31593l3.03764,6.48951.27616-8.97486Z",
    transform: "translate(-0.16734 -0.21595)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M23.94118,20.978l1.29739.58972L24.09191,23.326l-1.04728-.33071.89655-2.01723m-.4437-1.16824-1.6569,3.728,2.62342.82845,2.07112-3.17572-3.03764-1.38073Z",
    transform: "translate(-0.16734 -0.21595)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M26.30956,22.91569,33.15593,39.098l-.70115,1.32438-3.95357-1.28224-3.8522-14.086,1.66055-2.1385m.22556-1.72519L23.6842,24.862l4.09359,14.9686,5.10876,1.6569,1.24267-2.34727L26.53512,21.1905Z",
    transform: "translate(-0.16734 -0.21595)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "27.334 48.589 34.618 43.941 36.997 40.945 33.296 38.567"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "42.283 25.791 47.305 22.091 48.362 29.139 36.997 40.945"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "32.151 35.219 42.283 25.791 47.305 22.091 41.402 23.236 31.094 32.399 32.151 35.219"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M33.7836,12.86607l1.53373,4.74062.01241.79429-.63962-.19544-2.65463-.81113-.51569-2.96524,2.2638-1.5631m1.55495,6.09862.147,9.40966-2.03536,1.993L35.3011,19.19082l.03745-.22613M34.25678,11.47l-3.7004,2.555.70484,4.05283,3.17177.96915L32.14226,32.87952l4.229-4.14093-.17621-11.27742L34.25678,11.47Z",
    transform: "translate(-0.16734 -0.21595)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "28.715 27.553 31.094 17.862 30.565 13.897 27.393 23.765 28.715 27.553"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22.23358,7.5813l1.12392.36451,5.0106,13.69563-.52186,1.07271L22.23358,7.5813M20.77675,6.18376,27.737,24.95009l1.58588-3.25988L24.03662,7.241,20.77675,6.18376Z",
    transform: "translate(-0.16734 -0.21595)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "19.464 16.1 19.728 6.232 18.495 7.642 17.878 15.131 19.464 16.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "15.235 18.302 17.261 15.131 21.49 25.791 22.019 35.042 15.235 18.302"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "11.27 23.677 12.328 21.298 20.874 38.302 17.526 36.188 11.27 23.677"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "16.116 39.36 17.173 36.981 20.786 39.624 19.464 43.148 16.116 39.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "16.38 35.042 11.535 31.078 11.358 28.17 14.09 30.813 16.38 35.042"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "20.874 38.302 19.376 42.267 26.865 47.025"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 18.23057,
    y1: 24.64602,
    x2: 12.50375,
    y2: 21.91477
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaveCard);
export default __webpack_public_path__ + "static/media/CaveCard.c899ce937aa2e539c7ab22c86f0c0272.svg";
export { ForwardRef as ReactComponent };